import { css, html, LitElement } from "lit";
import { property } from "lit/decorators/property.js";
import "@shoelace-style/shoelace/dist/components/badge/badge.js";

export class BeamInfoPill extends LitElement {
  @property({ type: String }) infoText = "";

  static get styles() {
    return css`
      sl-badge::part(base) {
        background-color: var(--beam-pillLabel-color-background, #000);
        color: var(--beam-pillLabel-color, #fff);
        border: var(--beam-pillLabel-border-width, 3px) solid var(--beam-pillLabel-border, #000);
        border-radius: 18.37px;
        font-family: var(--beam-pillLabel-font, inherit);
        font-size: var(--beam-pillLabel-font-size, 12px);
        font-style: var(--beam-pillLabel-font-style, italic);
        font-weight: var(--beam-pillLabel-font-weight, bold);
        text-transform: var(--beam-pillLabel-text-transform, none);
        padding: var(--beam-pillLabel-padding, 3px 4px);
      }
    `;
  }

  render() {
    return html`<sl-badge pill aria-label="${this.infoText}">${this.infoText}</sl-badge>`;
  }
}

customElements.get("beam-info-pill") || customElements.define("beam-info-pill", BeamInfoPill);

export const infoPillLabelConfigDefaults = {
  "--beam-pillLabel-color-background": "#0A323C",
  "--beam-pillLabel-color": "#fff",
  "--beam-pillLabel-border": "#0A323C",
  "--beam-pillLabel-border-width": "1px",
  "--beam-pillLabel-font-size": "10px",
  "--beam-pillLabel-font": "inherit",
  "--beam-pillLabel-font-weight": "400",
  "--beam-pillLabel-text-transform": "none",
  "--beam-pillLabel-font-style": "italic",
  "--beam-pillLabel-padding": "3px 4px",
} as const;

declare global {
  interface HTMLElementTagNameMap {
    "beam-info-pill": BeamInfoPill;
  }
}
